import { render, staticRenderFns } from "./Entradas.vue?vue&type=template&id=143be6ab&scoped=true&"
import script from "./Entradas.vue?vue&type=script&lang=js&"
export * from "./Entradas.vue?vue&type=script&lang=js&"
import style0 from "./Entradas.vue?vue&type=style&index=0&id=143be6ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143be6ab",
  null
  
)

export default component.exports